// MainLayoutAdmin.tsx

import React from 'react';
import MainLayoutBase from '../MainLayoutBase';
import FidesChatPanel from './FidesChatPanel';
import FidesChatTray from './FidesChatTray';

// These imports are only available in the admin build
import { JobProvider } from 'JobContext';

interface Props {
  children: React.ReactNode;
  minimal?: boolean;
}

export default function MainLayoutAdmin({ children, minimal }: Props) {
  return (
    <JobProvider>
      <MainLayoutBase
        minimal={minimal}
        appendSection={() => <FidesChatTray />}
        avatarBgColor="hotpink"
      >
        {children}
      </MainLayoutBase>
      <FidesChatPanel />
    </JobProvider>
  );
}
